import { DbTimestampGenerated } from '@harvestiq/utils';
import { z } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Selectable } from 'kysely';

export interface ApiKeysTable {
  id: GeneratedAlways<string>;
  userId: string;
  label: string;
  clientId: string;
  clientSecret: string;
  enabled: boolean;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
}

export type DbApiKeys = Selectable<ApiKeysTable>;

export const dbApiKeySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  label: z.string(),
  clientId: z.string(),
  clientSecret: z.string().optional(),
  enabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

expectTypeOf<DbApiKeys>().toMatchTypeOf<z.infer<typeof dbApiKeySchema>>();
